import { render, staticRenderFns } from "./WeaponBuildItem.vue?vue&type=template&id=16729fa7"
import script from "./WeaponBuildItem.vue?vue&type=script&lang=ts"
export * from "./WeaponBuildItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports